import { DsTypography } from '@pulsepointinc/design-system-react';

export const renderCategoryWithHashHighlight = (category: string) => {
  const lastHashIndex = category.lastIndexOf('#');
  if (lastHashIndex === -1) return category;

  const label = category.slice(0, lastHashIndex);
  const code = category.slice(lastHashIndex);

  return (
    <>
      {label}
      <DsTypography as="span" color="secondary">
        {code}
      </DsTypography>
    </>
  );
};
